// extracted by mini-css-extract-plugin
export default {"timer":"HuzE_3ycdx7_hQdvvKGK","label":"zXD9ziXtNvxgC2ZYrGRW","counter":"iTDRsqpZuwI1xVahWI12","hours":"BJDp6TQuZyxVzstYj759","minutes":"_CpvUvDqlMrLlnvkSDCb"};